import { Form } from '@unform/web';
import styled from 'styled-components';

export const MyForm = styled(Form)`
  display: flex;
  flex-direction: column;

  flex: 1;

  height: 100%;

  overflow-y: auto;

  padding: 1rem;

  > div:not(:first-child) {
    margin-top: 1rem;
  }
`;

export const DrawerContent = styled.div`
  width: 40rem;
  height: 100%;

  display: flex;
  flex-direction: column;

  padding: 1rem;

  form {
    flex: 1;
  }
`;

export const DrawerActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  padding: 1rem;

  button {
    margin-left: 1rem;
  }
`;
